const resource = {
    resource_identifier_in_use: 'API 識別碼 {{indicator}} 已經被使用',
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
